import React from "react";
import {
  UserNoticeContainer,
  HeaderContainer,
  ContentContainer,
} from "./UserNoticeModal.styled";
import CloseIcon from "@material-ui/icons/Close";

const UserNoticeModal = ({ header, content, onClose }) => {
  return (
    <UserNoticeContainer>
      <HeaderContainer>
        <label>{header}</label>
        <CloseIcon onClick={onClose} />
      </HeaderContainer>
      <ContentContainer>
        <p>{content}</p>
      </ContentContainer>
    </UserNoticeContainer>
  );
};

export default UserNoticeModal;
